export enum WorkbenchEvents {
  DocumentationOpened = 'workbench.help.DocumentationOpened',
  KeyboardShortcutsOpened = 'workbench.help.KeyboardShortcutsOpened'
}
